<div class="login-container" [ngClass]="{'ecran-connexion-sans-modal': !rafraichirLogin}">
	<fieldset [ngClass]="{'ecran-connexion-sans-modal': !rafraichirLogin}">
		<form class="login">
			<div class="titre-application">
				{{ estApplicationSigale ? 'SIGALE' : '' }}<span><strong>{{ 'MENU.TITRE_APPLICATION' | translate }}</strong></span>
			</div>
			<bouton-sso-azure (erreur)="onLoginErreur($event)" (authentifie)="onLoginSSOSucces()"
			                  [estSsoOnly]="estSsoOnly"
			                  [(autresOptionsPossiblesVisible)]="autresOptionsPossiblesVisible">
			</bouton-sso-azure>
			@if (!estSsoOnly && autresOptionsPossiblesVisible) {
				<div [@slideFade]>
					<div class="grid-container">
						<span>{{ 'SIGALE_ANGULAR.COMPONENTS.LOGIN.IDENTIFIANT' | translate }}</span>
						<input class="form-control" type="text" name="login" [disabled]='!peutModifierLogin' [(ngModel)]="loginData.login"/>

						<span>{{ 'SIGALE_ANGULAR.COMPONENTS.LOGIN.PASSWORD' | translate }}</span>
						<input class="form-control" type="password" name="password" [(ngModel)]="loginData.password"/>
					</div>
					<div class="actions">
						<button class="btn btn-primary" (click)="login()" type="submit">{{ 'SIGALE_ANGULAR.COMPONENTS.LOGIN.CONNEXION' | translate }}</button>
					</div>
				</div>
				<div class="text-error text-center mt-2" *ngIf="message">
					{{ message }}
				</div>
			}
		</form>
	</fieldset>
</div>
